import {
	GlobalFooter,
	type CustomSection,
	type SocialLinkItem,
} from '@ds-mgnl/marketing';
import { type ImageProps } from '@dsx/react';
import footerLogo from '../../assets/images/ds-logo-color.svg';

export const Footer = () => {
	const logo: ImageProps = {
		src: footerLogo,
		alt: 'Direct Supply Logo',
	};

	const customSections: CustomSection[] = [
		{
			section: {
				title: 'Aptura',
			},
			linkGroups: [
				{
					links: [
						{
							href: '/services',
							children: 'Services',
						},
						{
							href: '/projects',
							children: 'Portfolio',
						},
						{
							href: '/resources/blogs',
							children: 'Expertise',
						},
						{
							href: '/news',
							children: 'News',
						},
						{
							href: '/about',
							children: 'About',
						},
					],
				},
			],
		},
	];

	const socialLinks: SocialLinkItem[] = [
		{
			href: 'https://www.facebook.com/directsupply',
			site: 'facebook',
		},
		{
			href: 'http://www.linkedin.com/company/direct-supply',
			site: 'linkedin',
		},
		{
			href: 'https://www.instagram.com/aptura_ds/',
			site: 'instagram',
		},
	];

	return (
		<>
			<GlobalFooter
				customSections={customSections}
				socialLinks={socialLinks}
				logo={logo}
			/>
		</>
	);
};
